import React from 'react';
import '../css/LegalPages.css';

const Corporate = () => {
  return (
    <div className="legal-container">
      <h1>Kurumsal</h1>

      <section>
        <h3>1. Halısahacım Hakkında</h3>
        <p>
          Halısahacım, Türkiye genelindeki halı saha işletmelerini ve oyuncuları 
          tek bir dijital ekosistem altında birleştiren kapsamlı bir rezervasyon, 
          iletişim ve tanıtım platformudur.
        </p>
        <p>
          Platformumuz; kullanıcıların hızlı şekilde saha bulmasını, müsaitlik durumlarını 
          görmesini, rezervasyon yapmasını ve işletmelerle doğrudan iletişime geçmesini sağlar.
        </p>
      </section>

      <section>
        <h3>2. Hizmet Modelimiz</h3>
        <p>
          Halısahacım, halı sahaların yönetim süreçlerini dijitalleştirmek ve kullanıcı deneyimini 
          iyileştirmek amacıyla geliştirilen bir SaaS (Software as a Service) modelidir.
        </p>
        <p>
          İşletmeler; kontrol paneli üzerinden:
        </p>
        <ul>
          <li>Rezervasyon takvimi oluşturabilir, düzenleyebilir</li>
          <li>Müsait saatleri yönetebilir</li>
          <li>Kullanıcılardan mesaj alabilir, yanıt verebilir</li>
          <li>Saha fotoğraflarını ve açıklamalarını güncelleyebilir</li>
          <li>Maç videolarını görüntüleyebilir ve yükleyebilir</li>
        </ul>
      </section>

      <section>
        <h3>3. Üyelik ve Ücretlendirme</h3>
        <p>
          İşletme üyelikleri aylık olarak ücretlendirilir. Ödeme tamamlandıktan sonra işletme profili 
          hemen aktif olur ve tüm özelliklere erişim sağlanır.
        </p>
        <p>
          Üyelik süresi boyunca işletmeler:
        </p>
        <ul>
          <li>Reklam görünürlüğü</li>
          <li>Rezervasyon yönetimi</li>
          <li>Özel mesajlaşma sistemi</li>
          <li>Video kayıt entegrasyonları (opsiyonel)</li>
        </ul>
      </section>

      <section>
        <h3>4. Güvenlik Politikamız</h3>
        <p>
          Platformdaki tüm kullanıcı verileri, modern güvenlik standartlarına uygun şekilde şifrelenmiş 
          veri tabanlarında saklanmaktadır. Hesap güvenliği için token tabanlı doğrulama kullanılmaktadır.
        </p>
        <p>
          Ödemeler, PCI-DSS uyumlu ödeme sağlayıcıları üzerinden yapılmaktadır.
        </p>
      </section>

      <section>
        <h3>5. Sorumluluk Reddi</h3>
        <p>
          Halısahacım, işletmeler tarafından paylaşılan içeriklerin (fotoğraf, açıklama, fiyat, çalışma 
          saatleri vb.) doğruluğundan sorumlu değildir. Bu bilgiler tamamen işletmenin kendi 
          sorumluluğundadır.
        </p>
        <p>
          Kullanıcılar arasında gerçekleşen iletişim ve saha içi etkileşimler Halısahacım’ın yükümlülüğünde değildir.
        </p>
      </section>

      <section>
        <h3>6. Veri Koruma ve KVKK</h3>
        <p>
          Tüm kullanıcı verileri 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında işlenmekte 
          ve korunmaktadır. Veri işleme süreçleri şeffaftır ve kullanıcı onayı olmadan hiçbir işlem yapılmaz.
        </p>
        <p>
          Detaylı bilgi için <a href="/kvkk">KVKK Aydınlatma Metni</a> sayfamızı inceleyebilirsiniz.
        </p>
      </section>

      <section>
        <h3>7. İş Birliği & Reklam</h3>
        <p>
          Halısahacım, reklam verenler, turnuva organizatörleri ve marka iş birlikleri için açık bir 
          platformdur. İş ortaklarımızla sürdürülebilir ve karşılıklı fayda sağlayan projeler geliştirmekteyiz.
        </p>
      </section>

      <section>
        <h3>8. İletişim</h3>
        <p>
          Kurumsal talepleriniz için bize ulaşabilirsiniz:<br />
          📧 <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a>
        </p>
      </section>
    </div>
  );
};

export default Corporate;
